export function byDefault (left, right) {
    return Math.sign(Number(Boolean(right.product.isDefault)) - Number(Boolean(left.product.isDefault)))
}

export function byPriceAsc (left, right) {
    return Math.sign(left.availability.priceQty.amount - right.availability.priceQty.amount)
}
